import { useEffect, useState } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import SaveIcon from '@mui/icons-material/Save';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import ActionButton from '../../../elements/action-button/ActionButton';
import Text from '../../../elements/text/Text';
import TextInput from '../../../elements/text-input/TextInput';
import Modal from '../../../sections/modal/Modal';
import { saveQuerySchema } from '../formValidation';
import { StyledModalButtonsWrapper } from '../styles';

const SaveQueryButton = ({ onSaveQuery }) => {
  const { t } = useTranslation();

  const [modal, setModal] = useState(false);

  const toggleModal = () => setModal(!modal);

  const handleSaveQuery = async (name) => {
    await onSaveQuery(name);
    toggleModal();
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    watch,
  } = useForm({ resolver: yupResolver(saveQuerySchema()) });

  useEffect(() => {
    if (!modal) return;
    reset();
  }, [modal]);

  return (
    <>
      <Button variant="outlined" startIcon={<SaveIcon />} onClick={toggleModal}>
        {t('save', { ns: 'buttons' })}
      </Button>
      <Modal
        openModal={modal}
        title={t('saveQuery', { ns: 'titles' })}
        handleClose={toggleModal}
      >
        <Text sx={{ mb: 3 }}>{t('saveQuery', { ns: 'descriptions' })}</Text>
        <form onSubmit={(e) => e.preventDefault()}>
          <TextInput
            name="queryName"
            label={t('search.queryName', { ns: 'fields' })}
            autoFocus
            shouldUnregister
            control={control}
            errors={errors}
            defaultValue=""
          />
          <StyledModalButtonsWrapper>
            <Button variant="text" onClick={toggleModal} color="inherit">
              {t('cancel', { ns: 'buttons' })}
            </Button>
            <ActionButton
              clickAction={handleSubmit(handleSaveQuery)}
              disabled={watch('queryName') === '' || errors?.queryName}
            >
              {t('save', { ns: 'buttons' })}
            </ActionButton>
          </StyledModalButtonsWrapper>
        </form>
      </Modal>
    </>
  );
};

SaveQueryButton.propTypes = {
  onSaveQuery: PropTypes.func.isRequired,
};

export default SaveQueryButton;
